import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/LanguageSwitcher';
import '../styles/About.css';

const About = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('experience');

  // Données du CV (à personnaliser)
  const experiences = [
    {
      id: 1,
      title: 'Développeur Full-Stack Freelance',
      company: 'Indépendant',
      location: 'Remote',
      period: '2024 - Présent',
      description: 'Développement d\'applications web et mobiles pour divers clients. Spécialisé en React, React Native et Node.js.',
      achievements: [
        'Plus de 20 projets livrés avec succès',
        'Satisfaction client de 98%',
        'Stack moderne et performante'
      ]
    },
    {
      id: 2,
      title: 'Développeur PHP SYMFONY',
      company: 'Arkema',
      location: 'Lyon, France',
      period: '2023 - 2024',
      description: "Stage de fin d'études pour la formation concepteur développeur d'application.",
      achievements: [
        "Refonte d'application web en PHP Symfony",
        "mise en place d'un système de gestion multilingue et de fichiers CSV avec CRON JOB pour l'automatisation des tâches",
        "Travail en équipe avec deux Lead Dev, méthode Agile Scrum"
      ]
    },
    {
      id: 3,
      title: 'Développeur Junior',
      company: 'Rouge Vert',
      location: 'Villefranche sur Saône, France',
      period: '2018 - 2020',
      description: 'Développement de sites web et applications pour des clients variés.',
      achievements: [
        'Apprentissage des best practices',
        'Collaboration en équipe Agile',
        'Premiers projets en production'
      ]
    }
  ];

  const education = [
    {
      id: 1,
      degree: 'Master Développement FullStack',
      description: 'Spécialisation en développement full-stack et architectures modernes'
    },
    {
      id: 2,
      degree: "Concepteur Développeur d'Applications",
      description: 'Spécialisation en développement full-stack'
    },
    {
      id: 3,
      degree: 'Développeur Web et Web Mobile',
      description: 'Fondamentaux de la programmation et des systèmes informatiques'
    }
  ];

  const skills = {
    frontend: [
      { name: 'React', level: 95 },
      { name: 'React Native', level: 90 },
      { name: 'JavaScript', level: 95 },
      { name: 'HTML/CSS', level: 98 },
      { name: 'Tailwind CSS', level: 85 }
    ],
    backend: [
      { name: 'Node.js', level: 90 },
      { name: 'Express', level: 88 },
      { name: 'MongoDB', level: 85 },
      { name: 'REST API', level: 92 },
      { name: 'JWT/Auth', level: 87 }
    ],
    tools: [
      { name: 'Git/GitHub', level: 90 },
      { name: 'VS Code', level: 95 },
      { name: 'Docker', level: 70 }
    ]
  };

//   const certifications = [
//     {
//       id: 1,
//       name: 'React Developer Certificate',
//       issuer: 'Meta',
//       year: '2023',
//       icon: '🎓'
//     },
//     {
//       id: 2,
//       name: 'Node.js Application Development',
//       issuer: 'OpenJS Foundation',
//       year: '2022',
//       icon: '📜'
//     },
//     {
//       id: 3,
//       name: 'JavaScript Algorithms and Data Structures',
//       issuer: 'freeCodeCamp',
//       year: '2021',
//       icon: '⚡'
//     }
//   ];

  const handleDownloadCV = () => {
    // Lien vers ton CV PDF dans le dossier assets
    const link = document.createElement('a');
    link.href = '/CV.pdf';
    link.download = 'Ibrahim_CV_2025.pdf';
    link.click();
  };

  return (
    <div className="about-container">
      {/* <LanguageSwitcher /> */}

      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-content">
          <div className="about-avatar">
            <div className="avatar-circle">
              <span className="avatar-initials">IB</span>
            </div>
            <div className="avatar-status">
              <span className="status-dot"></span>
              {t('about.available') || 'Disponible'}
            </div>
          </div>

          <h1 className="about-title">
            {t('about.name') || 'Ibra'} 👋
          </h1>
          <p className="about-role">
            {t('about.role') || 'Développeur Full-Stack'} • React • React Native • Node.js
          </p>

          <div className="about-actions">
            <button onClick={handleDownloadCV} className="download-cv-btn">
              <span>📄</span>
              {t('about.downloadCV') || 'Télécharger mon CV'}
            </button>
            <Link to="/contact-client" className="contact-btn">
              <span>💬</span>
              {t('about.contact') || 'Me contacter'}
            </Link>
          </div>
        </div>
      </section>

      {/* Bio Section */}
      <section className="about-bio">
        <div className="section-container">
          <h2 className="section-title">{t('about.bioTitle') || 'À propos de moi'}</h2>
          <p className="bio-text">
            {t('about.bio1') || 
              'Passionné par le développement web et mobile depuis plus de 6 ans, je crée des applications modernes, performantes et centrées sur l\'utilisateur. Mon approche combine expertise technique et créativité pour transformer vos idées en solutions digitales concrètes.'}
          </p>
          <p className="bio-text">
            {t('about.bio2') || 
              'Spécialisé en React et React Native, je maîtrise l\'ensemble de la stack JavaScript moderne. Que ce soit pour une application mobile cross-platform, un site web responsive ou une API robuste, je m\'adapte à vos besoins pour livrer un produit de qualité.'}
          </p>
        </div>
      </section>

      {/* Tabs Section */}
      <section className="about-tabs-section">
        <div className="section-container">
          <div className="tabs-header">
            <button
              className={`tab-btn ${activeTab === 'experience' ? 'active' : ''}`}
              onClick={() => setActiveTab('experience')}
            >
              <span>💼</span>
              {t('about.experience') || 'Expérience'}
            </button>
            <button
              className={`tab-btn ${activeTab === 'education' ? 'active' : ''}`}
              onClick={() => setActiveTab('education')}
            >
              <span>🎓</span>
              {t('about.education') || 'Formation'}
            </button>
            <button
              className={`tab-btn ${activeTab === 'skills' ? 'active' : ''}`}
              onClick={() => setActiveTab('skills')}
            >
              <span>⚡</span>
              {t('about.skills') || 'Compétences'}
            </button>
            {/* <button
              className={`tab-btn ${activeTab === 'certifications' ? 'active' : ''}`}
              onClick={() => setActiveTab('certifications')}
            >
              <span>🏆</span>
              {t('about.certifications') || 'Certifications'}
            </button> */}
          </div>

          <div className="tabs-content">
            {/* Experience Tab */}
            {activeTab === 'experience' && (
              <div className="timeline">
                {experiences.map((exp, index) => (
                  <div key={exp.id} className="timeline-item" style={{ animationDelay: `${index * 0.1}s` }}>
                    <div className="timeline-marker"></div>
                    <div className="timeline-content">
                      <div className="timeline-header">
                        <h3>{exp.title}</h3>
                        <span className="timeline-period">{exp.period}</span>
                      </div>
                      <p className="timeline-company">
                        {exp.company} • {exp.location}
                      </p>
                      <p className="timeline-description">{exp.description}</p>
                      <ul className="timeline-achievements">
                        {exp.achievements.map((achievement, idx) => (
                          <li key={idx}>{achievement}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Education Tab */}
            {activeTab === 'education' && (
              <div className="timeline">
                {education.map((edu, index) => (
                  <div key={edu.id} className="timeline-item" style={{ animationDelay: `${index * 0.1}s` }}>
                    <div className="timeline-marker"></div>
                    <div className="timeline-content">
                      <div className="timeline-header">
                        <h3>{edu.degree}</h3>
                        <span className="timeline-period">{edu.period}</span>
                      </div>
                      <p className="timeline-company">{edu.school}</p>
                      <p className="timeline-description">{edu.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Skills Tab */}
            {activeTab === 'skills' && (
              <div className="skills-grid">
                <div className="skill-category">
                  <h3>Frontend</h3>
                  {skills.frontend.map((skill) => (
                    <div key={skill.name} className="skill-item">
                      <div className="skill-header">
                        <span className="skill-name">{skill.name}</span>
                        <span className="skill-percent">{skill.level}%</span>
                      </div>
                      <div className="skill-bar">
                        <div 
                          className="skill-progress" 
                          style={{ width: `${skill.level}%` }}
                        ></div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="skill-category">
                  <h3>Backend</h3>
                  {skills.backend.map((skill) => (
                    <div key={skill.name} className="skill-item">
                      <div className="skill-header">
                        <span className="skill-name">{skill.name}</span>
                        <span className="skill-percent">{skill.level}%</span>
                      </div>
                      <div className="skill-bar">
                        <div 
                          className="skill-progress" 
                          style={{ width: `${skill.level}%` }}
                        ></div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="skill-category">
                  <h3>{t('about.tools') || 'Outils'}</h3>
                  {skills.tools.map((skill) => (
                    <div key={skill.name} className="skill-item">
                      <div className="skill-header">
                        <span className="skill-name">{skill.name}</span>
                        <span className="skill-percent">{skill.level}%</span>
                      </div>
                      <div className="skill-bar">
                        <div 
                          className="skill-progress" 
                          style={{ width: `${skill.level}%` }}
                        ></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Certifications Tab */}
            {/* {activeTab === 'certifications' && (
              <div className="certifications-grid">
                {certifications.map((cert, index) => (
                  <div 
                    key={cert.id} 
                    className="certification-card"
                    style={{ animationDelay: `${index * 0.1}s` }}
                  >
                    <span className="cert-icon">{cert.icon}</span>
                    <h3>{cert.name}</h3>
                    <p className="cert-issuer">{cert.issuer}</p>
                    <span className="cert-year">{cert.year}</span>
                  </div>
                ))}
              </div>
            )} */}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta">
        <h2>{t('about.ctaTitle') || 'Travaillons ensemble !'}</h2>
        <p>{t('about.ctaDescription') || 'Un projet en tête ? Discutons-en autour d\'un café ☕'}</p>
        <div className="cta-buttons">
          <Link to="/contact-client" className="cta-btn primary">
            💼 {t('about.startProject') || 'Démarrer un projet'}
          </Link>
          <Link to="/portfolio" className="cta-btn secondary">
            🎨 {t('about.viewPortfolio') || 'Voir mes projets'}
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;